/* eslint-disable react/prop-types */
import ColumnFilterSort from '../../components/tableClientSide/ColumnFilterSort';

export const getAccountNumberColumns = () => {
  return [
    {
      Header: ({ column }) => <ColumnFilterSort header='Account Number' column={column} align='right' />,
      width: 70,
      accessor: 'accountNumber'
    },
    {
      Header: ({ column }) => <ColumnFilterSort header='Status' column={column} align='right' />,
      width: 130,
      accessor: 'result'
    }
  ];
};
